<template>
    <div class="wrapper">
        <ul>
            <li @click="changeList(list)" v-for="list in lists" :key="list.id" :class="list.active ? 'active' : ''">
                {{list.name}}
                <i @click.stop="showDeleteModal(list)" class="material-icons">close</i>
            </li>
            <modal v-if="modalDelete" @accept="deleteList(listForDelete)" @close="modalDelete = false"></modal>
        </ul>
        <div class="add-list" @click="showCreateListForm" v-if="addListButton">
            <i class="material-icons">add</i>
        </div>
        <div class="create-list-form" v-else>
            <input @keyup.enter="!isDisable && createList()" type="text" v-model="insertedText" ref="input">
            <div class="button_wrapper">
                <a @click="cancelCreation" class="waves-effect waves-light btn btn-delete"><i class="material-icons">cancel</i></a>
                <a @click="createList" :disabled="isDisable" class="waves-effect waves-light btn btn-complete"><i class="material-icons">done</i></a>
            </div>
        </div>
    </div>
</template>

<script>
import modal from './modal'

export default {
  data () {
    return {
      addListButton: true,
      insertedText: '',
      modalDelete: false,
      listForDelete: {}
    }
  },
  props: ['lists'],
  computed: {
    isDisable () {
      return this.insertedText === ''
    }
  },
  methods: {
    changeList (list) {
      this.$store.dispatch('changeList', list)
    },
    createList (e) {
      this.$store.dispatch('createList', this.insertedText)
      this.insertedText = ''
      this.cancelCreation()
    },
    cancelCreation () {
      this.addListButton = !this.addListButton
    },
    showCreateListForm () {
      this.addListButton = !this.addListButton
      setTimeout(() => this.$refs.input.focus(), 0)
    },
    deleteList ({id, active}) {
      this.$store.dispatch('deleteList', id)
      this.$store.dispatch('deleteTasksByList', id)
      if (active) this.$store.dispatch('makeActiveFirst')
    },
    showDeleteModal (list) {
      this.listForDelete = list
      this.modalDelete = true
    }
  },
  components: {
    modal
  }
}
</script>

<style lang="scss" scoped>
    ul {
        list-style-type: none;
        margin: 0;
        padding: 20px 0;
        li {
            padding: 12px 25px;
            padding-right: 38px;
            overflow: hidden;
            cursor: pointer;
            position: relative;
            &:hover {
                box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
                background-color: #fff;
            }
            &.active {
                font-weight: bold;
                background-color: #fff;
                box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
            }
            i{
                position: absolute;
                right: 20px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 16px;
                transition: color .5s;

                &:hover{
                    color: #e53935;
                }
            }
        }
    }

    .add-list {
        background-color: #fff;
        margin: auto;
        height: 40px;
        width: 40px;
        border-radius: 2px;
        text-align: center;
        transition: background-color .5s;
        cursor: pointer;
        i {
            line-height: 40px;
            margin: auto;
        }
        &:hover{
            background-color: rgb(214, 214, 214);
        }
    }

    .create-list-form {
        display: flex;
        flex-direction: column;
        align-items: center;
        input {
            background-color: rgba(255, 255, 255, 0.753);
            width: 80%;
            padding-left: 15px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue